module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/40c4ef8d5ee49892ab68d3040f4eee36.png";